import classnames from 'classnames';
import { AlertTriangle, Info } from 'react-feather';

import styles from './Note.module.scss';

interface NoteProps {
  className?: string;
  icon?: JSX.Element | null;
  children: string | JSX.Element | JSX.Element[];
  variant?: 'info' | 'warning';
}

export default function Note({
  className,
  icon,
  children,
  variant = 'info',
}: NoteProps): JSX.Element {
  const defaultIcon = variant === 'warning' ? <AlertTriangle /> : <Info />;

  const classes = classnames(
    className,
    styles.Note,
    variant === 'warning' ? styles.NoteWarning : styles.NoteInfo
  );

  return (
    <div className={classes}>
      {icon ?? defaultIcon}
      <div>{children}</div>
    </div>
  );
}
